import awards from "../../shared/fr.awards";
import branded_quotes from "../../shared/fr.branded-quotes";
import verticals from "./fr-education-primary.verticals";
const pageFooter = ({ strings }) => {
    return {
        awards: {
            visible: true,
            title: {
                content: strings.awards_header_label,
                align: "center",
                type: "section-title"
            },
            panels: awards({ strings })
        },
        branded_quotes: {
            visible: true,
            title: {
                content: strings.branded_quotes_header_label,
                align: "center",
                type: "section-title"
            },
            panels: branded_quotes({ strings })
        },
        verticals: {
            visible: true,
            title: {
                content: strings.verticals_label,
                align: "center",
                type: "section-title"
            },
            panels: verticals({ strings })
        }
    };
};
export default ({ page, strings }) => {
    switch (page) {
        case "fr-education-primary-contact":
            return {
                page,
                helmet: {
                    meta_title: "Contact | Rosetta Stone",
                    meta_description:
                        "Les solutions d’apprentissage des langues de Rosetta Stone pour l’enseignement primaire et secondaire vont de pair avec l’enseignement donné en classe et sont accessibles à tout instant aux apprenants qui désirent apprendre ou perfectionner leur connaissance de l’anglais et des autres langues du globe.",
                    canonical_url: "https://www.rosettastone.com/ecoles-primaires-secondaires/contact/",
                    lang: "fr"
                },
                ...pageFooter({ strings })
            };
        case "fr-education-primary-home":
            return {
                page,
                helmet: {
                    meta_title: "L’apprentissage des langues de la maternelle au lycée | Rosetta Stone",
                    meta_description:
                        "Rosetta Stone training solutions help employees develop language skills in English for business and many in-demand business languages. Request pricing.  ",
                    canonical_url: "https://www.rosettastone.fr/education/",
                    lang: "fr"
                },
                ...pageFooter({ strings })
            };
        case "fr-education-primary-solutions":
            return {
                page,
                helmet: {
                    meta_title:
                        "Programmes d’apprentissage des langues en ligne pour l´Education primaire et secondaire| Rosetta Stone",
                    meta_description:
                        "Les programmes d’apprentissage des langues en ligne de Rosetta Stone motivent les étudiants en anglais et les apprenants des langues étrangères en leur donnant la confiance nécessaire pour commencer à s’exprimer. Demandez nos tarifs",
                    canonical_url: "https://www.rosettastone.fr/education/solutions/",
                    lang: "fr"
                },
                ...pageFooter({ strings })
            };
        case "fr-education-primary-dynamic-resources":
            return {
                page,
                helmet: {
                    meta_title: "",
                    meta_description: "",
                    canonical_url: "",
                    lang: "fr"
                },
                ...pageFooter({ strings })
            };
        case "fr-education-primary-dynamic-content":
            return {
                page,
                helmet: {
                    meta_title: "",
                    meta_description: "",
                    canonical_url: "",
                    lang: "fr"
                },
                ...pageFooter({ strings })
            };
        case "fr-education-primary-404":
            return {
                page,
                helmet: {
                    meta_title: "Site non trouvé | Rosetta Stone",
                    meta_description: "",
                    canonical_url: "https://www.rosettastone.com/business/404",
                    lang: "fr"
                },
                ...pageFooter({ strings })
            };
        default:
            return null;
    }
};
